// 大洲分类全球地区json数据
export const areaOptions = [
  {
      "c_name": "亚洲",
      "label": "Asia",
      "value": "Asia",
      "children": [
          {
              "c_name": "中国",
              "label": "China",
              "value": "China",
              "abbreviation": "CN"
          },
          {
              "c_name": "泰国",
              "label": "Thailand",
              "value": "Thailand",
              "abbreviation": "THA"
          },
          {
              "c_name": "日本",
              "label": "Japan",
              "value": "Japan",
              "abbreviation": "JPN"
          },
          {
              "c_name": "新加坡",
              "label": "Singapore",
              "value": "Singapore",
              "abbreviation": "SGP"
          },
          {
              "c_name": "马来西亚",
              "label": "Malaysia",
              "value": "Malaysia",
              "abbreviation": "MYS"
          },
          {
              "c_name": "韩国",
              "label": "Korea",
              "value": "Korea",
              "abbreviation": "KR"
          },
          {
              "c_name": "越南",
              "label": "Vietnam",
              "value": "Vietnam",
              "abbreviation": "VNM"
          },
          {
              "c_name": "马尔代夫",
              "label": "Maldives",
              "value": "Maldives",
              "abbreviation": "MDV"
          },
          {
              "c_name": "菲律宾",
              "label": "Philippines",
              "value": "Philippines",
              "abbreviation": "PHL"
          },
          {
              "c_name": "印度尼西亚",
              "label": "Indonesia",
              "value": "Indonesia",
              "abbreviation": "IDN"
          },
          {
              "c_name": "柬埔寨",
              "label": "Cambodia",
              "value": "Cambodia",
              "abbreviation": "KHM"
          },
          {
              "c_name": "斯里兰卡",
              "label": "Sri Lanka",
              "value": "Sri Lanka",
              "abbreviation": "LKA"
          },
          {
              "c_name": "土耳其",
              "label": "Turkey",
              "value": "Turkey",
              "abbreviation": "TUR"
          },
          {
              "c_name": "尼泊尔",
              "label": "Nepal",
              "value": "Nepal",
              "abbreviation": "NPL"
          },
          {
              "c_name": "印度",
              "label": "India",
              "value": "India",
              "abbreviation": "IND"
          },
          {
              "c_name": "阿联酋",
              "label": "United Arab Emirates",
              "value": "United Arab Emirates",
              "abbreviation": "UAE"
          },
          {
              "c_name": "缅甸",
              "label": "Myanmar",
              "value": "Myanmar",
              "abbreviation": "MMR"
          },
          {
              "c_name": "老挝",
              "label": "Laos",
              "value": "Laos",
              "abbreviation": "LAO"
          },
          {
              "c_name": "以色列",
              "label": "Israel",
              "value": "Israel",
              "abbreviation": "ISR"
          },
          {
              "c_name": "伊朗",
              "label": "Iran",
              "value": "Iran",
              "abbreviation": "IRN"
          },
          {
              "c_name": "朝鲜",
              "label": "North Korea",
              "value": "North Korea",
              "abbreviation": "PRK"
          },
          {
              "c_name": "格鲁吉亚",
              "label": "Georgia",
              "value": "Georgia",
              "abbreviation": "GEO"
          },
          {
              "c_name": "文莱",
              "label": "Brunei Darussalam",
              "value": "Brunei Darussalam",
              "abbreviation": "BN"
          },
          {
              "c_name": "约旦",
              "label": "Jordan",
              "value": "Jordan",
              "abbreviation": "JOR"
          },
          {
              "c_name": "巴基斯坦",
              "label": "Pakistan",
              "value": "Pakistan",
              "abbreviation": "PAK"
          },
          {
              "c_name": "蒙古",
              "label": "Mongolia",
              "value": "Mongolia",
              "abbreviation": "MNG"
          },
          {
              "c_name": "不丹",
              "label": "Bhutan",
              "value": "Bhutan",
              "abbreviation": "BTN"
          },
          {
              "c_name": "塞浦路斯",
              "label": "Cyprus",
              "value": "Cyprus",
              "abbreviation": "CYP"
          },
          {
              "c_name": "孟加拉国",
              "label": "Bangladesh",
              "value": "Bangladesh",
              "abbreviation": "BGD"
          },
          {
              "c_name": "卡塔尔",
              "label": "Qatar",
              "value": "Qatar",
              "abbreviation": "QAT"
          },
          {
              "c_name": "哈萨克斯坦",
              "label": "Kazakhstan",
              "value": "Kazakhstan",
              "abbreviation": "KAZ"
          },
          {
              "c_name": "亚美尼亚",
              "label": "Armenia",
              "value": "Armenia",
              "abbreviation": "ARM"
          },
          {
              "c_name": "叙利亚",
              "label": "Syria",
              "value": "Syria",
              "abbreviation": "SYR"
          },
          {
              "c_name": "阿塞拜疆",
              "label": "Azerbaijan",
              "value": "Azerbaijan",
              "abbreviation": "AZE"
          },
          {
              "c_name": "黎巴嫩",
              "label": "Lebanon",
              "value": "Lebanon",
              "abbreviation": "LBN"
          },
          {
              "c_name": "沙特阿拉伯",
              "label": "Saudi Arabia",
              "value": "Saudi Arabia",
              "abbreviation": "SAU"
          },
          {
              "c_name": "阿曼",
              "label": "Oman",
              "value": "Oman",
              "abbreviation": "OMN"
          },
          {
              "c_name": "也门",
              "label": "Yemen",
              "value": "Yemen",
              "abbreviation": "YEM"
          },
          {
              "c_name": "巴林",
              "label": "Bahrain",
              "value": "Bahrain",
              "abbreviation": "BHR"
          },
          {
              "c_name": "阿富汗",
              "label": "Afghanistan",
              "value": "Afghanistan",
              "abbreviation": "AFG"
          },
          {
              "c_name": "乌兹别克斯坦",
              "label": "Uzbekistan",
              "value": "Uzbekistan",
              "abbreviation": "UZB"
          },
          {
              "c_name": "吉尔吉斯斯坦",
              "label": "Kyrgyzstan",
              "value": "Kyrgyzstan",
              "abbreviation": "KGZ"
          },
          {
              "c_name": "伊拉克",
              "label": "Iraq",
              "value": "Iraq",
              "abbreviation": "IRQ"
          },
          {
              "c_name": "东帝汶",
              "label": "Timor-Leste",
              "value": "Timor-Leste",
              "abbreviation": "TL"
          },
          {
              "c_name": "塔吉克斯坦",
              "label": "Tajikistan",
              "value": "Tajikistan",
              "abbreviation": "TJK"
          },
          {
              "c_name": "巴勒斯坦",
              "label": "Palestinian Authority",
              "value": "Palestinian Authority",
              "abbreviation": "PSE"
          },
          {
              "c_name": "土库曼斯坦",
              "label": "Turkmenistan",
              "value": "Turkmenistan",
              "abbreviation": "TKM"
          },
          {
              "c_name": "科威特",
              "label": "Kuwait",
              "value": "Kuwait",
              "abbreviation": "KWT"
          }
      ]
  },
  {
      "c_name": "欧洲",
      "label": "Europe",
      "value": "Europe",
      "children": [
          {
              "c_name": "意大利",
              "label": "Italy",
              "value": "Italy",
              "abbreviation": "ITA"
          },
          {
              "c_name": "法国",
              "label": "France",
              "value": "France",
              "abbreviation": "FRA"
          },
          {
              "c_name": "英国",
              "label": "United Kingdom",
              "value": "United Kingdom",
              "abbreviation": "GBR"
          },
          {
              "c_name": "德国",
              "label": "Germany",
              "value": "Germany",
              "abbreviation": "DE"
          },
          {
              "c_name": "俄罗斯",
              "label": "Russia",
              "value": "Russia",
              "abbreviation": "RUS"
          },
          {
              "c_name": "白俄罗斯",
              "label": "Belarus",
              "value": "Belarus",
              "abbreviation": "BY"
          },
          {
              "c_name": "西班牙",
              "label": "Spain",
              "value": "Spain",
              "abbreviation": "ESP"
          },
          {
              "c_name": "瑞士",
              "label": "Switzerland",
              "value": "Switzerland",
              "abbreviation": "CHE"
          },
          {
              "c_name": "希腊",
              "label": "Greece",
              "value": "Greece",
              "abbreviation": "GRC"
          },
          {
              "c_name": "荷兰",
              "label": "Netherlands",
              "value": "Netherlands",
              "abbreviation": "NLD"
          },
          {
              "c_name": "捷克共和国",
              "label": "Czech Republic",
              "value": "Czech Republic",
              "abbreviation": "CZ"
          },
          {
              "c_name": "奥地利",
              "label": "Austria",
              "value": "Austria",
              "abbreviation": "AUT"
          },
          {
              "c_name": "冰岛",
              "label": "Iceland",
              "value": "Iceland",
              "abbreviation": "ISL"
          },
          {
              "c_name": "挪威",
              "label": "Norway",
              "value": "Norway",
              "abbreviation": "NOR"
          },
          {
              "c_name": "芬兰",
              "label": "Finland",
              "value": "Finland",
              "abbreviation": "FIN"
          },
          {
              "c_name": "葡萄牙",
              "label": "Portugal",
              "value": "Portugal",
              "abbreviation": "PRT"
          },
          {
              "c_name": "比利时",
              "label": "Belgium",
              "value": "Belgium",
              "abbreviation": "BEL"
          },
          {
              "c_name": "塞尔维亚",
              "label": "Serbia",
              "value": "Serbia",
              "abbreviation": "SRB"
          },
          {
              "c_name": "瑞典",
              "label": "Sweden",
              "value": "Sweden",
              "abbreviation": "SWE"
          },
          {
              "c_name": "丹麦",
              "label": "Denmark",
              "value": "Denmark",
              "abbreviation": "DNK"
          },
          {
              "c_name": "匈牙利",
              "label": "Hungary",
              "value": "Hungary",
              "abbreviation": "HUN"
          },
          {
              "c_name": "梵蒂冈",
              "label": "Vatican City",
              "value": "Vatican City",
              "abbreviation": "VAT"
          },
          {
              "c_name": "克罗地亚",
              "label": "Croatia",
              "value": "Croatia",
              "abbreviation": "HRV"
          },
          {
              "c_name": "波兰",
              "label": "Poland",
              "value": "Poland",
              "abbreviation": "POL"
          },
          {
              "c_name": "爱尔兰",
              "label": "Ireland",
              "value": "Ireland",
              "abbreviation": "IRL"
          },
          {
              "c_name": "马耳他",
              "label": "Malta",
              "value": "Malta",
              "abbreviation": "MLT"
          },
          {
              "c_name": "乌克兰",
              "label": "Ukraine",
              "value": "Ukraine",
              "abbreviation": "UKR"
          },
          {
              "c_name": "卢森堡",
              "label": "Luxembourg",
              "value": "Luxembourg",
              "abbreviation": "WLX"
          },
          {
              "c_name": "摩纳哥",
              "label": "Monaco",
              "value": "Monaco",
              "abbreviation": "MCO"
          },
          {
              "c_name": "塞浦路斯",
              "label": "Cyprus",
              "value": "Cyprus",
              "abbreviation": "CYP"
          },
          {
              "c_name": "斯洛文尼亚",
              "label": "Slovenia",
              "value": "Slovenia",
              "abbreviation": "SVN"
          },
          {
              "c_name": "爱沙尼亚",
              "label": "Estonia",
              "value": "Estonia",
              "abbreviation": "EST"
          },
          {
              "c_name": "斯洛伐克",
              "label": "Slovakia",
              "value": "Slovakia",
              "abbreviation": "SVK"
          },
          {
              "c_name": "保加利亚",
              "label": "Bulgaria",
              "value": "Bulgaria",
              "abbreviation": "BGR"
          },
          {
              "c_name": "罗马尼亚",
              "label": "Romania",
              "value": "Romania",
              "abbreviation": "ROU"
          },
          {
              "c_name": "列支敦士登",
              "label": "Liechtenstein",
              "value": "Liechtenstein",
              "abbreviation": "LIE"
          },
          {
              "c_name": "波黑",
              "label": "Bosnia and Herzegovina",
              "value": "Bosnia and Herzegovina",
              "abbreviation": "BIH"
          },
          {
              "c_name": "黑山",
              "label": "Montenegro",
              "value": "Montenegro",
              "abbreviation": "MNE"
          },
          {
              "c_name": "安道尔",
              "label": "The Principality of Andorra",
              "value": "The Principality of Andorra",
              "abbreviation": "AD"
          },
          {
              "c_name": "拉脱维亚",
              "label": "Latvia",
              "value": "Latvia",
              "abbreviation": "LVA"
          },
          {
              "c_name": "白俄罗斯",
              "label": "White Russia",
              "value": "White Russia",
              "abbreviation": "BLR"
          },
          {
              "c_name": "立陶宛",
              "label": "Lithuania",
              "value": "Lithuania",
              "abbreviation": "LTU"
          },
          {
              "c_name": "圣马力诺",
              "label": "San Marino",
              "value": "San Marino",
              "abbreviation": "SMR"
          },
          {
              "c_name": "北马其顿",
              "label": "North Macedonia",
              "value": "North Macedonia",
              "abbreviation": "MKD"
          },
          {
              "c_name": "阿尔巴尼亚",
              "label": "Albania",
              "value": "Albania",
              "abbreviation": "ALB"
          },
          {
              "c_name": "摩尔多瓦",
              "label": "Moldova",
              "value": "Moldova",
              "abbreviation": "MDA"
          },
          {
              "c_name": "科索沃",
              "label": "Kosovo",
              "value": "Kosovo",
              "abbreviation": "KOS"
          },
          {
              "c_name": "直布罗陀",
              "label": "Gibraltar",
              "value": "Gibraltar",
              "abbreviation": "GI"
          },
          {
              "c_name": "北马其顿",
              "label": "North Macedonia",
              "value": "North Macedonia",
              "abbreviation": "MK"
          }
      ]
  },
  {
      "c_name": "北美洲",
      "label": "North America",
      "value": "North America",
      "children": [
          {
              "c_name": "美国",
              "label": "United States",
              "value": "United States",
              "abbreviation": "USA"
          },
          {
              "c_name": "加拿大",
              "label": "Canada",
              "value": "Canada",
              "abbreviation": "CAN"
          },
          {
              "c_name": "墨西哥",
              "label": "Mexico",
              "value": "Mexico",
              "abbreviation": "MEX"
          },
          {
              "c_name": "古巴",
              "label": "Cuba",
              "value": "Cuba",
              "abbreviation": "CUB"
          },
          {
              "c_name": "巴哈马",
              "label": "Bahamas",
              "value": "Bahamas",
              "abbreviation": "BHS"
          },
          {
              "c_name": "哥斯达黎加",
              "label": "Costa Rica",
              "value": "Costa Rica",
              "abbreviation": "CR"
          },
          {
              "c_name": "巴拿马",
              "label": "Panama",
              "value": "Panama",
              "abbreviation": "PAN"
          },
          {
              "c_name": "牙买加",
              "label": "Jamaica",
              "value": "Jamaica",
              "abbreviation": "JAM"
          },
          {
              "c_name": "多米尼加",
              "label": "Dominica",
              "value": "Dominica",
              "abbreviation": "DMA"
          },
          {
              "c_name": "危地马拉",
              "label": "Guatemala",
              "value": "Guatemala",
              "abbreviation": "GTM"
          },
          {
              "c_name": "海地",
              "label": "Haiti",
              "value": "Haiti",
              "abbreviation": "HTI"
          },
          {
              "c_name": "巴巴多斯",
              "label": "Barbados",
              "value": "Barbados",
              "abbreviation": "BRB"
          },
          {
              "c_name": "伯利兹",
              "label": "Belize",
              "value": "Belize",
              "abbreviation": "BLZ"
          },
          {
              "c_name": "洪都拉斯",
              "label": "Honduras",
              "value": "Honduras",
              "abbreviation": "HND"
          },
          {
              "c_name": "安提瓜和巴布达",
              "label": "Antigua and Barbuda",
              "value": "Antigua and Barbuda",
              "abbreviation": "ATG"
          },
          {
              "c_name": "尼加拉瓜",
              "label": "Nicaragua",
              "value": "Nicaragua",
              "abbreviation": "NIC"
          },
          {
              "c_name": "多米尼克",
              "label": "Dominica",
              "value": "Dominica",
              "abbreviation": "DMA"
          },
          {
              "c_name": "波多黎各",
              "label": "Puerto Rico",
              "value": "Puerto Rico",
              "abbreviation": "PR"
          },
          {
              "c_name": "萨尔瓦多",
              "label": "El Salvador",
              "value": "El Salvador",
              "abbreviation": "SLV"
          },
          {
              "c_name": "特立尼达和多巴哥共和国",
              "label": "Trinidad and Tobago",
              "value": "Trinidad and Tobago",
              "abbreviation": "TT"
          },
          {
              "c_name": "圣基茨和尼维斯",
              "label": "Saint Kitts and Nevis",
              "value": "Saint Kitts and Nevis",
              "abbreviation": "KN"
          },
          {
              "c_name": "圣卢西亚",
              "label": "St.Lucia",
              "value": "St.Lucia",
              "abbreviation": "LCA"
          },
          {
              "c_name": "格林纳达",
              "label": "Grenada",
              "value": "Grenada",
              "abbreviation": "GRD"
          },
          {
              "c_name": "圣文森特和格林纳丁斯",
              "label": "Saint Vincent and the Grenadines",
              "value": "Saint Vincent and the Grenadines",
              "abbreviation": "VC"
          },
          {
              "c_name": "百慕大",
              "label": "Bermuda",
              "value": "Bermuda",
              "abbreviation": "BM"
          },
          {
              "c_name": "开曼群岛",
              "label": "Cayman Islands",
              "value": "Cayman Islands",
              "abbreviation": "CY"
          },
          {
              "c_name": "格陵兰",
              "label": "Greenland",
              "value": "Greenland",
              "abbreviation": "GL"
          },
          {
              "c_name": "蒙特塞拉特",
              "label": "Montserrat",
              "value": "Montserrat",
              "abbreviation": "MS"
          },
          {
              "c_name": "多米尼克联邦",
              "label": "The Commonwealth of Dominica",
              "value": "The Commonwealth of Dominica",
              "abbreviation": "DM"
          },
          {
              "c_name": "多米尼加共和国",
              "label": "Dominican Republic",
              "value": "Dominican Republic",
              "abbreviation": "DO"
          },
          {
              "c_name": "特克斯和凯科斯群岛",
              "label": "Turks and Caicos Islands",
              "value": "Turks and Caicos Islands",
              "abbreviation": "TC"
          },
          {
              "c_name": "美属维尔京群岛",
              "label": "Vigin Islands(U.S.)",
              "value": "Vigin Islands(U.S.)",
              "abbreviation": "VI"
          },
          {
              "c_name": "英属维尔京群岛",
              "label": "Virgin Islands(British)",
              "value": "Virgin Islands(British)",
              "abbreviation": "BVI"
          },
      ]
  },
  {
      "c_name": "大洋洲",
      "label": "Oceania",
      "value": "Oceania",
      "children": [
          {
              "c_name": "新西兰",
              "label": "New Zealand",
              "value": "New Zealand",
              "abbreviation": "NZL"
          },
          {
              "c_name": "澳大利亚",
              "label": "Australia",
              "value": "Australia",
              "abbreviation": "AUS"
          },
          {
              "c_name": "瓦努阿图",
              "label": "Vanuatu",
              "value": "Vanuatu",
              "abbreviation": "VU"
          },
          {
              "c_name": "汤加",
              "label": "Tonga",
              "value": "Tonga",
              "abbreviation": "TON"
          },
          {
              "c_name": "巴布亚新几内亚",
              "label": "Papua New Guinea",
              "value": "Papua New Guinea",
              "abbreviation": "PNG"
          },
          {
              "c_name": "萨摩亚",
              "label": "Samoa",
              "value": "Samoa",
              "abbreviation": "WSM"
          },
          {
              "c_name": "所罗门群岛",
              "label": "Solomon Islands",
              "value": "Solomon Islands",
              "abbreviation": "SLB"
          },
          {
              "c_name": "基里巴斯",
              "label": "Kiribati",
              "value": "Kiribati",
              "abbreviation": "KIR"
          },
          {
              "c_name": "托克劳",
              "label": "Tokelau",
              "value": "Tokelau",
              "abbreviation": "TK"
          },
          {
              "c_name": "瑙鲁",
              "label": "Nauru",
              "value": "Nauru",
              "abbreviation": "NRU"
          },
          {
              "c_name": "库克群岛",
              "label": "Cook Islands",
              "value": "Cook Islands",
              "abbreviation": "CK"
          },
          {
              "c_name": "斐济",
              "label": "Fiji",
              "value": "Fiji",
              "abbreviation": "FJ"
          },
          {
              "c_name": "法属波利尼西亚",
              "label": "French Polynesia",
              "value": "French Polynesia",
              "abbreviation": "PF"
          },
          {
              "c_name": "关岛",
              "label": "Guam",
              "value": "Guam",
              "abbreviation": "GU"
          },
          {
              "c_name": "马绍尔群岛",
              "label": "Marshall Islands",
              "value": "Marshall Islands",
              "abbreviation": "MH"
          },
          {
              "c_name": "密克罗尼西亚",
              "label": "Micronesia",
              "value": "Micronesia",
              "abbreviation": "FM"
          },
          {
              "c_name": "新喀里多尼亚",
              "label": "New Caledonia",
              "value": "New Caledonia",
              "abbreviation": "NC"
          },
          {
              "c_name": "纽埃",
              "label": "Niue",
              "value": "Niue",
              "abbreviation": "NU"
          },
          {
              "c_name": "诺福克",
              "label": "Norfolk",
              "value": "Norfolk",
              "abbreviation": "NF"
          },
          {
              "c_name": "北马里亚纳群岛",
              "label": "Northern Mariana Islands",
              "value": "Northern Mariana Islands",
              "abbreviation": "MP"
          },
          {
              "c_name": "帕劳群岛",
              "label": "Palau",
              "value": "Palau",
              "abbreviation": "PW"
          },
          {
              "c_name": "皮特凯恩",
              "label": "Pitcairn",
              "value": "Pitcairn",
              "abbreviation": "PN"
          },
          {
              "c_name": "图瓦卢",
              "label": "Tuvalu",
              "value": "Tuvalu",
              "abbreviation": "TV"
          },
      ]
  },
  {
      "c_name": "非洲",
      "label": "Africa",
      "value": "Africa",
      "children": [
          {
              "c_name": "埃及",
              "label": "Egypt",
              "value": "Egypt",
              "abbreviation": "EGY"
          },
          {
              "c_name": "摩洛哥",
              "label": "Morocco",
              "value": "Morocco",
              "abbreviation": "MAR"
          },
          {
              "c_name": "南非",
              "label": "South Africa",
              "value": "South Africa",
              "abbreviation": "ZAF"
          },
          {
              "c_name": "肯尼亚",
              "label": "Kenya",
              "value": "Kenya",
              "abbreviation": "KEN"
          },
          {
              "c_name": "坦桑尼亚",
              "label": "Tanzania",
              "value": "Tanzania",
              "abbreviation": "TZA"
          },
          {
              "c_name": "突尼斯",
              "label": "Tunisia",
              "value": "Tunisia",
              "abbreviation": "TUN"
          },
          {
              "c_name": "马达加斯加",
              "label": "Madagascar",
              "value": "Madagascar",
              "abbreviation": "MDG"
          },
          {
              "c_name": "纳米比亚",
              "label": "Namibia",
              "value": "Namibia",
              "abbreviation": "NAM"
          },
          {
              "c_name": "埃塞俄比亚",
              "label": "Ethiopia",
              "value": "Ethiopia",
              "abbreviation": "ETH"
          },
          {
              "c_name": "津巴布韦",
              "label": "Zimbabwe",
              "value": "Zimbabwe",
              "abbreviation": "ZWE"
          },
          {
              "c_name": "乌干达",
              "label": "Uganda",
              "value": "Uganda",
              "abbreviation": "UGA"
          },
          {
              "c_name": "加纳",
              "label": "Ghana",
              "value": "Ghana",
              "abbreviation": "GHA"
          },
          {
              "c_name": "赞比亚",
              "label": "Zambia",
              "value": "Zambia",
              "abbreviation": "ZMB"
          },
          {
              "c_name": "尼日利亚",
              "label": "Nigeria",
              "value": "Nigeria",
              "abbreviation": "NGA"
          },
          {
              "c_name": "苏丹",
              "label": "Sudan",
              "value": "Sudan",
              "abbreviation": "SDN"
          },
          {
              "c_name": "安哥拉",
              "label": "Angola",
              "value": "Angola",
              "abbreviation": "AGO"
          },
          {
              "c_name": "马里",
              "label": "Mali",
              "value": "Mali",
              "abbreviation": "MLI"
          },
          {
              "c_name": "马拉维",
              "label": "Malawi",
              "value": "Malawi",
              "abbreviation": "MWI"
          },
          {
              "c_name": "尼日尔",
              "label": "Niger",
              "value": "Niger",
              "abbreviation": "NER"
          },
          {
              "c_name": "几内亚",
              "label": "Guinea",
              "value": "Guinea",
              "abbreviation": "GIN"
          },
          {
              "c_name": "卢旺达",
              "label": "Rwanda",
              "value": "Rwanda",
              "abbreviation": "RWA"
          },
          {
              "c_name": "索马里",
              "label": "Somalia",
              "value": "Somalia",
              "abbreviation": "SOM"
          },
          {
              "c_name": "中非共和国",
              "label": "The Central African Republic",
              "value": "The Central African Republic",
              "abbreviation": "CF"
          },
          {
              "c_name": "吉布提",
              "label": "Djibouti",
              "value": "Djibouti",
              "abbreviation": "DJI"
          },
          {
              "c_name": "西撒哈拉",
              "label": "Western Sahara",
              "value": "Western Sahara",
              "abbreviation": "WSH"
          },
          {
              "c_name": "阿尔及利亚",
              "label": "Algeria",
              "value": "Algeria",
              "abbreviation": "DZA"
          },
          {
              "c_name": "贝宁",
              "label": "Benin",
              "value": "Benin",
              "abbreviation": "BJ"
          },
          {
              "c_name": "博茨瓦纳",
              "label": "Botswana",
              "value": "Botswana",
              "abbreviation": "BW"
          },
          {
              "c_name": "布基纳法索",
              "label": "Burkina Faso",
              "value": "Burkina Faso",
              "abbreviation": "BF"
          },
          {
              "c_name": "布隆迪",
              "label": "Burundi",
              "value": "Burundi",
              "abbreviation": "BDI"
          },
          {
              "c_name": "喀麦隆",
              "label": "Cameroon",
              "value": "Cameroon",
              "abbreviation": "CMR"
          },
          {
              "c_name": "佛得角",
              "label": "Cape Verde",
              "value": "Cape Verde",
              "abbreviation": "CPV"
          },
          {
              "c_name": "乍得",
              "label": "Chad",
              "value": "Chad",
              "abbreviation": "TCD"
          },
          {
              "c_name": "科特迪瓦",
              "label": "Coate d'Ivorie",
              "value": "Coate d'Ivorie",
              "abbreviation": "CIV"
          },
          {
              "c_name": "科摩罗",
              "label": "Comoros",
              "value": "Comoros",
              "abbreviation": "KM"
          },
          {
              "c_name": "刚果",
              "label": "Congo",
              "value": "Congo",
              "abbreviation": "CG"
          },
          {
              "c_name": "赤道几内亚",
              "label": "Equatorial Guinea",
              "value": "Equatorial Guinea",
              "abbreviation": "GQ"
          },
          {
              "c_name": "厄立特里亚",
              "label": "Eritrea",
              "value": "Eritrea",
              "abbreviation": "ER"
          },
          {
              "c_name": "加蓬",
              "label": "Gabon",
              "value": "Gabon",
              "abbreviation": "GA"
          },
          {
              "c_name": "冈比亚",
              "label": "Gambia",
              "value": "Gambia",
              "abbreviation": "GM"
          },
          {
              "c_name": "几内亚比绍",
              "label": "Guinea-Bissau",
              "value": "Guinea-Bissau",
              "abbreviation": "GW"
          },
          {
              "c_name": "莱索托",
              "label": "Lesotho",
              "value": "Lesotho",
              "abbreviation": "LS"
          },
          {
              "c_name": "利比里亚",
              "label": "Liberia",
              "value": "Liberia",
              "abbreviation": "LR"
          },
          {
              "c_name": "利比亚",
              "label": "Libya",
              "value": "Libya",
              "abbreviation": "LY"
          },
          {
              "c_name": "毛里塔尼亚",
              "label": "Mauritania",
              "value": "Mauritania",
              "abbreviation": "MR"
          },
          {
              "c_name": "毛里求斯",
              "label": "Mauritius",
              "value": "Mauritius",
              "abbreviation": "MU"
          },
          {
              "c_name": "莫桑比克",
              "label": "Mozambique",
              "value": "Mozambique",
              "abbreviation": "MZ"
          },
          {
              "c_name": "圣多美和普林西比",
              "label": "Sao Tome and Principe",
              "value": "Sao Tome and Principe",
              "abbreviation": "ST"
          },
          {
              "c_name": "塞内加尔",
              "label": "Senegal",
              "value": "Senegal",
              "abbreviation": "SN"
          },
          {
              "c_name": "塞舌尔",
              "label": "Seychelles",
              "value": "Seychelles",
              "abbreviation": "SC"
          },
          {
              "c_name": "塞拉利昂",
              "label": "Sierra Leone",
              "value": "Sierra Leone",
              "abbreviation": "SL"
          },
          {
              "c_name": "圣赫勒拿",
              "label": "Saint Helena",
              "value": "Saint Helena",
              "abbreviation": "SH"
          },
          {
              "c_name": "斯威士兰",
              "label": "Eswatini",
              "value": "Eswatini",
              "abbreviation": "SZ"
          },
          {
              "c_name": "多哥",
              "label": "Togo",
              "value": "Togo",
              "abbreviation": "TG"
          },
      ]
  },
  {
      "c_name": "南美洲",
      "label": "South America",
      "value": "South America",
      "children": [
          {
              "c_name": "巴西",
              "label": "Brazil",
              "value": "Brazil",
              "abbreviation": "BRA"
          },
          {
              "c_name": "秘鲁",
              "label": "Peru",
              "value": "Peru",
              "abbreviation": "PER"
          },
          {
              "c_name": "阿根廷",
              "label": "Argentina",
              "value": "Argentina",
              "abbreviation": "ARG"
          },
          {
              "c_name": "玻利维亚",
              "label": "Bolivia",
              "value": "Bolivia",
              "abbreviation": "BOL"
          },
          {
              "c_name": "智利",
              "label": "Chile",
              "value": "Chile",
              "abbreviation": "CHL"
          },
          {
              "c_name": "厄瓜多尔",
              "label": "Ecuador",
              "value": "Ecuador",
              "abbreviation": "ECU"
          },
          {
              "c_name": "哥伦比亚",
              "label": "Colombia",
              "value": "Colombia",
              "abbreviation": "COL"
          },
          {
              "c_name": "委内瑞拉",
              "label": "Venezuela",
              "value": "Venezuela",
              "abbreviation": "VEN"
          },
          {
              "c_name": "乌拉圭",
              "label": "Uruguay",
              "value": "Uruguay",
              "abbreviation": "URY",
          },
          {
              "c_name": "苏里南",
              "label": "Suriname",
              "value": "Suriname",
              "abbreviation": "SUR",
          },
          {
              "c_name": "圭亚那",
              "label": "Guyana",
              "value": "Guyana",
              "abbreviation": "GUY",
          },
          {
              "c_name": "巴拉圭",
              "label": "Paraguay",
              "value": "Paraguay",
              "abbreviation": "PRY",
          },
          {
              "c_name": "法属圭亚那",
              "label": "French Guiana",
              "value": "French Guiana",
              "abbreviation": "GF",
          }
      ]
  },
  {
      "c_name": "南极洲",
      "label": "Antarctica",
      "value": "Antarctica",
      "isLeaf":true
  },
]